<template>
  <CommonModal
    class="confirm-modal"
    :title="config.title"
    :footer="null"
    :width="684"
    :maskClosable="false"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div class="confirm-modal-inner">
      <div v-html="config.text"></div>
      <p class='pdf'><a :href="config.pdfLink" target='_blank'>{{config.pdfTitle}}</a></p>
      <p class='confirm-modal-button-warp'><a-button class="confirm-modal-button" :href="config.link"  target='_blank' type="primary" @click="close">{{config.button}}</a-button></p>
    </div>
  </CommonModal>
</template>

<script>
  import { Button } from 'ant-design-vue'
  import CommonModal from '@/components/common-modal'

  export default {
    name: "confirm-modal",
    components: {
      CommonModal,
      [Button.name]: Button,
    },
    data() {
      return {
        config: {}
      }
    },
    async created() {
      // this.$store.dispatch('queryIsNeedStamp')
      const json = await this.$store.dispatch('queryModalCMSConfig')
      this.config = json.config || {}
      // console.log(this.$attrs, this.$listeners)
    },
    methods: {
      close() {
        this.$emit('cancel')
      }
    }
  }
</script>

<style lang="scss" scoped>
.confirm-modal-inner{
  padding: 2px 40px;
  color: #000;
  height: 290px;
  overflow-y: auto;
}
.btn {
  width: 120px;
  & + .btn {
    margin-left: 15px;
  }
}
.confirm-modal-button-warp{
  text-align: center;
  padding-top: 24px;
}
.confirm-modal-button{
  width: 140px;
  height: 40px;
  line-height: 40px;
  // background: $primary-main;
  // color: #fff;
  // display: block;
  border-radius: 4px;
}
.pdf{
  padding-top:16px;
  font-size: 14px;
  color: $text-blue;
  line-height: 22px;
}
</style>
